<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
    <div class="full-search-2 eclip-search italian-search hero-search-radius shadow-hard mt-5">
        <div class="hero-search-content">
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-12 b-r">
                    <div class="form-group">
                        <div class="choose-propert-type">
                            <ul>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" id="typbuy" name="typeprt">
                                        <label class="form-check-label" for="typbuy">For Buy</label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" id="typrent" name="typeprt" checked>
                                        <label class="form-check-label" for="typrent">For Rent</label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-6 col-md-4 col-sm-12 p-md-0 elio">
                    <div class="form-group border-start borders">
                        <div class="position-relative">
                            <input type="text" class="form-control border-0 ps-5" placeholder="Search for a location">
                            <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                <span class="svg-icon text-primary svg-icon-2hx">
                                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z" fill="currentColor"/>
                                        <path d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z" fill="currentColor"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-1 col-md-1 col-sm-2">
                    <div class="form-group">
                        <a class="collapsed ad-search" data-bs-toggle="collapse" href="#advance-search" role="button" aria-expanded="false" aria-controls="advance-search"><i class="fa fa-sliders-h"></i></a>
                    </div>
                </div>
                
                <div class="col-lg-2 col-md-3 col-sm-12">
                    <div class="form-group">
                        <button type="button" class="btn btn-primary full-width">Search</button>
                    </div>
                </div>
            </div>
            <div class="collapse" id="advance-search">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="form-group mb-2">
                            <div class="position-relative">
                                <Multiselect v-model="selected" :options="town" placeholder="City/Town" class="form-control px-0 border ps-5"/>
                                <i class="fa-solid fa-location-dot text-muted position-absolute" style="top: 40%; left:5%"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="form-group mb-2">
                            <div class="position-relative">
                                <Multiselect v-model="selected" :options="rooms" placeholder="Bedrooms" class="form-control px-0 border ps-5"/>
                                <i class="fas fa-bed text-muted position-absolute" style="top: 40%; left:5%"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="form-group mb-2">
                            <div class="position-relative">
                                <Multiselect v-model="selected" :options="rooms" placeholder="Bathrooms" class="form-control px-0 border ps-5"/>
                                <i class="fas fa-bed text-muted position-absolute" style="top: 40%; left:5%"></i>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="form-group mb-2">
                            <input type="text" class="form-control" placeholder="min price" />
                        </div>
                    </div>
                    
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="form-group mb-2">
                            <input type="text" class="form-control" placeholder="max price" />
                        </div>
                    </div>
                    
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="form-group mb-2">
                            <input type="text" class="form-control" placeholder="min sqft" />
                        </div>
                    </div>
                    
                    <div class="col-lg-3 col-md-6 col-sm-6">
                        <div class="form-group mb-2">
                            <input type="text" class="form-control" placeholder="max sqft" />
                        </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 mt-2">
                        <h6 class="mb-4">Advance Price</h6>
                        <RangeSlider/>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
                        <h4 class="text-dark fs-6 fw-semibold">Amenities & Features</h4>
                        <ul class="no-ul-list third-row">
                            <li>
                                <div class="form-check">
                                    <input id="a-1" class="form-check-input" name="a-1" type="checkbox">
                                    <label for="a-1" class="form-check-label">Air Condition</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-2" class="form-check-input" name="a-2" type="checkbox">
                                    <label for="a-2" class="form-check-label">Bedding</label>
                                </div>
                            </li>
                            <li>
                                <input id="a-3" class="form-check-input" name="a-3" type="checkbox">
                                <label for="a-3" class="form-check-label ms-2">Heating</label>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-4" class="form-check-input" name="a-4" type="checkbox">
                                    <label for="a-4" class="form-check-label">Internet</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-5" class="form-check-input" name="a-5" type="checkbox">
                                    <label for="a-5" class="form-check-label">Microwave</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-6" class="form-check-input" name="a-6" type="checkbox">
                                    <label for="a-6" class="form-check-label">Smoking Allow</label>
                                </div>	
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-7" class="form-check-input" name="a-7" type="checkbox">
                                    <label for="a-7" class="form-check-label">Terrace</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-8" class="form-check-input" name="a-8" type="checkbox">
                                    <label for="a-8" class="form-check-label">Balcony</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-9" class="form-check-input" name="a-9" type="checkbox">
                                    <label for="a-9" class="form-check-label">Icon</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-10" class="form-check-input" name="a-10" type="checkbox">
                                    <label for="a-10" class="form-check-label">Wi-Fi</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-11" class="form-check-input" name="a-11" type="checkbox">
                                    <label for="a-11" class="form-check-label">Beach</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input id="a-12" class="form-check-input" name="a-12" type="checkbox">
                                    <label for="a-12" class="form-check-label">Parking</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    import Multiselect from '@vueform/multiselect';
    import '@vueform/multiselect/themes/default.css';
    import RangeSlider from './range-slider.vue';

    const town = ref([
        'Any Town',
        'Toronto',
        'Montreal',
        'Alberta',
        'Ontario',
        'Ottawa',
    ])

    const rooms = ref(['1','2','3','4','5','6'])
</script>
